var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#38AEC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.666 16.1667H21.3327C19.2493 16.1667 17.166 18.0417 17.166 20.3333V26.6042C17.166 28.1042 18.0618 29.3958 19.2493 30.125V53.6667C19.2493 55.9583 21.541 57.8333 23.416 57.8333H52.5827C54.4577 57.8333 56.7494 55.9583 56.7494 53.6667V30.125C57.9369 29.3958 58.8327 28.1042 58.8327 26.6042V20.3333C58.8327 18.0417 56.7494 16.1667 54.666 16.1667ZM44.2494 41.1667H31.7493V37H44.2494V41.1667ZM54.666 26.5833H21.3327V20.3333H54.666V26.5833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryLarge);
export default __webpack_public_path__ + "static/media/inventory_large.eafdf3029d5951e45a8541291cb8a0d0.svg";
export { ForwardRef as ReactComponent };